export enum PageLayout {
    OneColumn = 'OneColumn',
    TwoColumns = 'TwoColumns',
    ThreeColumns = 'ThreeColumns',
}

export interface AdsPaginationState {
    firstPagePath: string;
    pagePath: string;
    numberOfPages: number;
    currentPage: number;
}
